import {createReducer} from '@reduxjs/toolkit'
import * as types from './types'

const filterReducer = createReducer(
  {
    filtering: false,
    filterFailed: false,
    filterSucceeded: false,
  },
  {
    [types.FILTER]: (state, action) => ({
      ...state,      

      filtering: true,
      filterFailed: false,
      filterSucceeded: false,
    }),
    [types.FILTER_SUCCESS]: (state, action) => ({
      ...state,
      lookupData: action.lookupData,

      filtering: false,
      filterFailed: false,
      filterSucceeded: true,
    }),
    [types.FILTER_FAIL]: (state, action) => ({
      ...state,
      lookupData: action.lookupData,

      filtering: false,
      filterFailed: true,
      filterSucceeded: false,
    }),
    [types.FILTER_RESET]: (state, action) => ({
      ...state,

      filtering: false,
      filterFailed: false,
      filterSucceeded: false,
    }),
  }
)

export default filterReducer